export default [
  {
    title: "Tag",
    customIcon: "TagSVG",
    children: [
      {
        title: "Tag List",
        route: "tags-list",
        path: "/tags/list",
      },
    ],
  },
];
